<script setup>
import { Link } from "@inertiajs/vue3";
</script>

<template>
    <Link :href="'/'">
        <div style="max-width: 150px">
            <img width="125" src="/logo.svg" />
        </div>
    </Link>
</template>
